const ITEMS = [
  "Scopri i Prodotti Esposti",
  "Nuovo Catalogo",
  "Talk A.I. nel mondo Automotive",
  "45 Anni Insieme",
  "Open Day · 25 Ottobre 2026",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-8 font-display text-xs font-semibold uppercase tracking-[0.35em] text-white/90">{item}</span>
        <span className="h-1.5 w-1.5 rotate-45 bg-white/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="marquee-mask overflow-hidden bg-[#E30613] py-5" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
